exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sm-disable-scroll{overflow:hidden!important}.sm-body_mobile.sm-disable-scroll{position:fixed!important}body.sm-disable-scroll:not(.sm-body_mobile){position:fixed!important;width:100%;overflow-y:scroll!important;padding-right:0!important}.sm-disable-scroll #cities-select-container-overlay{z-index:9999999}.sm-disable-scroll #cities-select-container,.sm-disable-scroll .arcticmodal-container,.sm-disable-scroll .arcticmodal-overlay,.sm-disable-scroll .dropdown-menu.show{z-index:99999999}body.sm-disable-scroll .header{border-color:#fff}", ""]);

// exports
